import React, { useEffect, useState } from "react";
import getDayOfYear from "date-fns/getDayOfYear";
import getOptimizedSrc from "_shared/useOptimizedImage";
import shadow from "_shared/images/overlay-vignette.png";
import { useTranslation } from "react-i18next";
import { Button } from "@applied-med/ui/dist/components";
import { useLocation } from "react-router-dom";

const testingImages = false; // set to 'true' when testing new set images

function getDayOfYearMod(max) {
  // update by monday
  return getDayOfYear(new Date()) % max;
}

const getImagesNames = () => {
  const r = require.context("_shared/images/backgrounds/2025/", true);
  const importAll = (r) =>
    r.keys().map((file) => {
      return file.replace("./", "");
    });
  return importAll(r);
};

const images = getImagesNames();

async function getImage(templateName) {
  try {
    let template = await import(
      "_shared/images/backgrounds/2025/" + templateName
    );
    return template.default;
  } catch (err) {
    console.error(err);
    return new Error(err);
  }
}

const ImageProvider = ({ children, width, height }) => {
  const [imgsrc, setImgSrc] = useState("");
  const [imgCred, setImgCred] = useState("");
  const [imgIndex, setImgIndex] = useState(getDayOfYearMod(images.length));
  const { t } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    const fetchImage = async () => {
      const chosenImageName = testingImages
        ? images[imgIndex]
        : images[getDayOfYearMod(images.length)];
      const photoCredit = chosenImageName
        .replace(".jpg", "")
        .replace(".png", "")
        .replace(/\d/, "")
        .trim()
        .split(" - ")
        .splice(-1);
      const img = await getImage(chosenImageName);
      setImgCred(photoCredit);
      setImgSrc(getOptimizedSrc(img, width).src);
    };
    fetchImage();
  }, [width, imgIndex]);

  // used only for testing new images
  const handleClick = () => {
    setImgIndex((prevIndex) =>
      prevIndex >= images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // used only for testing new images
  const handlePrev = () => {
    setImgIndex((prevIndex) =>
      prevIndex <= 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div
      data-cy="background-image"
      style={{
        backgroundImage: `url("${
          getOptimizedSrc(shadow, width).src
        }"), url("${imgsrc}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height,
      }}
    >
      <div
        style={{
          color: "white",
          position: "absolute",
          bottom: 13,
          right: 43,
          fontSize: 13,
          display: "block",
        }}
      >
        <div className="flex items-center">
          {testingImages && location.pathname === "/" && (
            <div>
              <Button className="z-[1] mr-1 text-[11px]" onClick={handlePrev}>
                Prev
              </Button>
              <Button className="z-[1] mr-3 text-[11px]" onClick={handleClick}>
                Change Background
              </Button>
            </div>
          )}
          {testingImages && ` (#${imgIndex + 1} / ${images.length})`}
        </div>
      </div>
      {children}
    </div>
  );
};

export default ImageProvider;
